module.exports = __webpack_public_path__ + "static/media/egg_plate_98.5d03a287.png";